import React, { useState } from "react"
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import Footer from "../components/App/Footer"
import SEO from "../components/App/SEO"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
// Carousel
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

// Images (replace with your own paths)
import ai_image from "../assets/images/futuristic-ai-chip-circuit-board.png"
import ai_banner2 from "../assets/images/futuristic-robot-artificial-intelligence-concept.png"
import ai_banner3 from "../assets/images/robot-humanoid-using-tablet-computer-big-data-analytic.png"
import dentalAppointment from "../assets/images/Group-148805.png"
import hotelConcierge from "../assets/images/Group-148806.png"
import airlinesAssistant from "../assets/images/Group-148807.png"
import retailAssistant from "../assets/images/Group-148808.png"
import healthcareSupport from "../assets/images/Group-148809.png"
import aiImage from "../assets/images/Group 148459.png"
import aiImageFrame from "../assets/images/Group-148811.png"
import blur from "../assets/images/blur.png"
import voice from "../assets/images/voice.png"
import playButton from "../assets/images/play-button.png"
import aiImageBg from "../assets/images/Rectangle-43615.png"
import aiSolutionsImage from "../assets/images/Group 144869.png"
// Add your new background images
import networkBgImage from "../assets/images/Group 148462.png" // Image 3
import dotsBgImage from "../assets/images/Group 148461.png" // Image 2

const aiAgents = [
  {
    title: "Dental Clinic Appointment",
    subtitle: "Speak with AI to schedule your dental appointment.",
    image: dentalAppointment,
    buttonText: "Create an agent like this",
  },
  {
    title: "Hotel Concierge",
    subtitle: "Speak with a hotel concierge.",
    image: hotelConcierge,

    buttonText: "Create an agent like this",
  },
  {
    title: "Airlines Assistant",
    subtitle: "Talk to a virtual travel assistant.",
    image: airlinesAssistant,
    buttonText: "Create an agent like this",
  },
  {
    title: "Retail Shopping Assistant",
    subtitle: "AI can recommend products and guide checkout.",
    image: retailAssistant,
    buttonText: "Create an agent like this",
  },
  {
    title: "Healthcare Support",
    subtitle: "AI can handle patient intake, FAQs, and reminders.",
    image: healthcareSupport,
    buttonText: "Create an agent like this",
  },
]

const aiSolutions = [
  {
    title: "AI Lead Generator",
    description:
      "Our AI voice agent is designed to transform your business's approach to lead generation, customer service follow-ups, confirmation calls, and appointment setting.",
    image: ai_image,
    buttonText: "Consult for FREE",
    videoText: "Watch a demo",
  },
  {
    title: "AI Appointment Setter",
    description:
      "Designed to handle inbound service calls efficiently, our AI voice agent can answer inquiries, schedule appointments, process payments, and send confirmations.",
    image: ai_banner2,
    buttonText: "Consult for FREE",
    videoText: "Watch a demo",
  },
  {
    title: "AI Support Agent",
    description:
      "Designed to handle a high volume of inquiries efficiently, our AI agent can answer common support questions, resolve basic issues, and seamlessly transfer complex problems to human agents.",
    image: ai_banner3,
    buttonText: "Consult for FREE",
    videoText: "Watch a demo",
  },
]

const faqData = [
  {
    question: "What happens after the free consultation?",
    answer: "After the free consultation, our team will analyze your requirements and provide a tailored AI solution roadmap for your project. This includes a detailed plan for development, integration, and deployment.",
  },
  {
    question: "Do I need to pay the full AI Service fee upfront?",
    answer: "No, we provide flexible payment options. You can start with a deposit and pay as milestones are achieved. We also offer transparent pricing with no hidden fees.",
  },
  {
    question: "Can I customize my package after posting a project?",
    answer: "Absolutely! You can adjust your AI package anytime to match your business needs. Whether you need more features, faster development, or lower costs, we have options to accommodate your requirements.",
  },
  {
    question: "How long does an AI agent take to develop?",
    answer: "Development time varies depending on project complexity — usually between 2–8 weeks.",
  },
  {
    question: "I have a specific AI project in mind that's not listed. Can you help me with it?",
    answer: "Yes! We provide custom AI solutions. Share your idea with us, and we’ll build a tailored plan for you. Whether it's a chatbot, a recommendation system, or any other AI-powered solution, we've got you covered.",
  },
  {
    question: "I want to bring my AI Action Plan to life. What steps should I take next?",
    answer: "Start by booking a consultation. Our experts will guide you through strategy, prototyping, and full-scale implementation. Whether you need a chatbot, a recommendation system, or any other AI-powered solution, we've got you covered.",
  },
]

// Carousel Section
function TryAiAgentSection() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  }

  return (
    <section
      className="py-5"
      id="try-ai-agent"
    // style={
    //   {
    //     // backgroundColor: "#ffffff",
    //     // backgroundImage: dotsBgImage ? `url(${dotsBgImage})` : "none",
    //     // backgroundRepeat: "repeat",
    //     // backgroundSize: "300px 300px",
    //     // backgroundPosition: "center",
    //     // position: "relative",
    //   }
    // }
    >
      {/* Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ backgroundColor: "rgba(255, 255, 255, 0.92)", zIndex: 1 }}
      ></div>

      <div
        className="container position-relative tryai-container"
        style={{ zIndex: 2 }}
      >
        <div className="row align-items-center mb-5">
          <div className="col-lg-8">
            <h2
              className="h3 fw-bold mb-4"
            // style={
            //   {
            //     color: "#2d3748",
            //     fontSize: "clamp(2rem, 4vw, 2.5rem)"
            //   }
            // }
            >
              Try out an AI agent for yourself
            </h2>
            <div className="d-flex flex-wrap gap-2 mb-3">
              {[
                "Retail & Consumer Goods",
                "HealthCare & Wellness",
                "Restaurants",
                "Hospitality & Tourism",
              ].map((category, index) => (
                <span
                  key={index}
                  className="badge rounded-pill px-3 py-2 try-category"
                // style={
                //   {
                //     // backgroundColor: "#f8f9fa",
                //     // color: "#6c757d",
                //     // border: "1px solid #dee2e6",
                //     // fontSize: "14px",
                //   }
                // }
                >
                  {category}
                </span>
              ))}
            </div>
          </div>
          <div className="col-lg-4 text-lg-end">
            <div className="d-flex align-items-center justify-content-lg-end flex-column">
              <div className="d-flex align-items-center mb-2">
                <span
                  className="me-3"
                  style={{ color: "#6c757d", fontSize: "14px" }}
                >
                  Powered by
                </span>
                <div className="d-flex align-items-center">
                  <div
                    className="powered-by"
                  // style={
                  //   {
                  //     // width: "24px",
                  //     // height: "24px",
                  //     // backgroundColor: "#2d3748",
                  //     // borderRadius: "4px",
                  //     // display: "flex",
                  //     // alignItems: "center",
                  //     // justifyContent: "center",
                  //     // marginRight: "8px",
                  //   }
                  // }
                  >
                    <img
                      src={blur}
                      alt="blur"
                      style={{ backgroundColor: "white" }}
                    />
                  </div>
                  <span
                    className="retell-ai"
                  // style={
                  //   {
                  //     // fontWeight: "600",
                  //     // fontSize: "18px",
                  //     // color: "#2d3748",
                  //   }
                  // }
                  >
                    Retell AI
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Carousel */}
        <Slider {...settings}>
          {aiAgents.map((agent, index) => (
            <div key={index} className="p-3">
              <div
                className="card text-white border-0 rounded-3 overflow-hidden position-relative try-slider"
                style={{
                  // height: "600px",
                  backgroundImage: `url(${agent.image})`,
                  // backgroundSize: "cover",
                  // backgroundPosition: "center",
                  // borderRadius: "0px !important",
                }}
              >
                {/* Overlay */}
                <div
                  className="position-absolute top-0 start-0 w-100 h-100"
                // style={{ background: "rgba(0,0,0,0.4)" }}
                ></div>

                <div className="card-body d-flex flex-column justify-content-between position-relative z-1 p-4">
                  {/* Title + subtitle */}
                  <div>
                    <h5 className="fw-bold">{agent.title}</h5>
                    <p className="small mb-0" style={{ color: "white" }}>
                      {agent.subtitle}
                    </p>
                  </div>

                  {/* Mic button */}
                  <div className="text-center mic-button">
                    <button
                      className="btn p-3"
                    // style={{ width: "80px", height: "65px" }}
                    >
                      <img
                        src={voice} // 👉 replace with your image path
                        alt="mic"
                      // style={{
                      //   width: "44px",
                      //   height: "44px",
                      //   objectFit: "contain",
                      // }}
                      />
                    </button>
                    <p style={{ color: "white" }}>try it out</p>
                  </div>

                  {/* CTA button */}
                  <div className="text-center">
                    <button className="btn btn-primary w-100">
                      {agent.buttonText}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  )
} // Close TryAiAgentSection function here

const AIDevelopment = () => {
  const [expandedFaq, setExpandedFaq] = useState(null)
  const toggleFaq = index =>
    setExpandedFaq(expandedFaq === index ? null : index)

  return (
    <Layout>
      <SEO
        title="AI Development Services | Hire AI Experts & Developers | SrashtaSoft"
        description="SrashtaSoft provides advanced AI development services to automate workflows, build custom AI solutions, and drive digital transformation. Consult for free today."
        canonical="https://srashtasoft.com/ai-development/"
        isServicePage
        serviceName="AI Development Services"
        faqData={faqData}
      />
      <Navbar />

      {/* Hero Section */}
      <section
        className="hero-section position-relative overflow-hidden hero"
      // style={
      //   {
      //     // minHeight: "90vh",
      //     // paddingTop: "80px",
      //     // paddingBottom: "0",
      //     // backgroundColor: "#fafafa",
      //     // position: "relative",
      //     // width: "100%",
      //   }
      // }
      >
        <div
          className="position-absolute sub-hero"
          style={{
            // top: "0",
            // right: "0",
            // width: "100%",
            // height: "100%",
            backgroundImage: `url(${networkBgImage})`,
            // backgroundRepeat: "no-repeat",
            // backgroundPosition: "right center",
            // backgroundSize: "contain",
            // zIndex: 1,
          }}
        ></div>

        <div
          className="container position-relative hero-container"
        // style={
        //   {
        //     // zIndex: 3,
        //     // width: "100%"
        //   }
        // }
        >
          <div
            className="align-items-center hero-subcontainer"
          // style={
          //   {
          //     // minHeight: "100vh",
          //     // paddingTop: "100px",
          //     // paddingLeft: "200px",
          //   }
          // }
          >
            <div className="hero-content">
              <p
                className="mb-3 text-start"
              // style={
              //   {
              //     // fontSize: "clamp(16px, 3vw, 30px)",
              //     // fontWeight: "400",
              //     // color: "#666",
              //     // letterSpacing: "0.5px",
              //     // paddingLeft: "9%",
              //   }
              // }
              >
                Transform your business with
              </p>

              <h1
                className="mb-4 text-start"
              // style={
              //   {
              //     // fontSize: "clamp(3.5rem, 8vw, 6.5rem)",
              //     // lineHeight: "0.9",
              //     // fontWeight: "900",
              //     // letterSpacing: "-10px",
              //     // textTransform: "uppercase",
              //     // fontFamily: "'Arial Black', sans-serif",
              //   }
              // }
              >
                <span
                  style={{
                    background:
                      "linear-gradient(180deg, #E53935 0%, #9C27B0 50%, #1E88E5 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    // display: "inline-block",
                    // marginRight: "-8px",
                  }}
                >
                  AI
                </span>
                <span style={{ color: "#2d3748" }}>DEVELOPMENT</span>
              </h1>

              <p
                className="mb-4 text-start hero-dec"
              // style={
              //   {
              //     // fontSize: "clamp(14px, 1.5vw, 18px)",
              //     // lineHeight: "1.6",
              //     // maxWidth: "980px",
              //     // color: "#555",
              //     // fontWeight: "400",
              //     // paddingLeft: "9%",
              //   }
              // }
              >
                What is AI Development? Imagine you can get AI to answer the
                phone, make sales, set appointments, and generally make your
                life way easier. It'll cost you less than building a website,
                and it's the next big thing for businesses in 2025.
              </p>

              <div className="text-start mb-5" style={{ paddingLeft: "9%" }}>
                <a
                  href="#try-ai-agent"
                  className="btn btn-lg px-5 py-3 hero-btn"
                // style={
                //   {
                //     // fontSize: "16px",
                //     // fontWeight: "600",
                //     // backgroundColor: "#4285f4",
                //     // borderColor: "#4285f4",
                //     // color: "#fff",
                //     // boxShadow: "0 4px 15px rgba(66, 133, 244, 0.3)",
                //     // borderRadius: "6px",
                //   }
                // }
                >
                  Explore our AI Services
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Try AI Agent Section with Carousel */}
      <TryAiAgentSection />

      {/* Excited Section */}
      <section
        className="py-5 bg-white exc-section"

      // style={{
      //   // backgroundColor: "rgba(255, 255, 255, 0.92)",
      //   // zIndex: 1,
      //   // display: "flex",
      //   // justifyContent: "center",
      //   // alignItems: "center",
      //   // padding: "0px 20px 0px 20px",
      // }}
      >
        <div
          className="container exc-container"
        // style={{ display: "flex" }}
        >
          <div className="exc-content">
            <h2
            // style={{ fontSize: "55px", fontWeight: "500" }}
            >
              Excited, but not sure where to begin?
            </h2>
            <p
              className="text-muted mb-4"
            // style={{ width: "600px" }}
            >
              Get started with a comprehensive AI Action Plan. Our experts will
              identify key areas where AI can supercharge your business and
              provide a clear roadmap.
            </p>
            <a href="#" className="btn btn-primary px-4">
              Get your FREE plan
            </a>
            <div
              className="mt-4 exc-img"

            // style={{
            //   // marginTop: "40px",
            //   // fontSize: "6rem",
            //   // fontWeight: "900",
            //   // textTransform: "uppercase",
            //   // background: `url(${aiImageFrame})`,
            //   // backgroundClip: "text",
            //   // letterSpacing: "2px",
            //   // paddingLeft: "250px",
            // }}
            >
              <img
                src={aiImage}
                alt="AI Action Plan"
                className="img-fluid rounded"
                style={{ maxHeight: "250px" }}
              />
            </div>
          </div>
          <div>
            <img
              src={aiImageFrame}
              alt="AI Action Plan"
              className="img-fluid rounded"
            // style={{
            //   // maxHeight: "290px",
            //   // marginRight: "-110px",
            // }}
            />
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          {aiSolutions.map((solution, index) => (
            <div
              key={index}
              className={`row align-items-center mb-5 ${index % 2 !== 0 ? "flex-row-reverse" : ""
                }`}
            >
              {/* Text Content */}
              <div className="col-lg-6 mb-4 mb-lg-0 aisolution-text">
                <h3
                  className="fw-bold mb-4"
                // style={{
                //   // fontSize: "clamp(2rem, 4vw, 3rem)",
                //   // color: "#2d3748",
                //   // lineHeight: "1.2",
                // }}
                >
                  {solution.title}
                </h3>
                <p
                  className="mb-4"
                // style={{
                //   // fontSize: "18px",
                //   // lineHeight: "1.6",
                //   // color: "#666",
                // }}
                >
                  {solution.description}
                </p>
                <a
                  href="#"
                  className="btn btn-primary rounded-pill px-4 py-2"
                // style={{
                //   // fontSize: "16px",
                //   // fontWeight: "600",
                //   // textDecoration: "none",
                // }}
                >
                  {solution.buttonText}
                </a>
              </div>

              {/* Image + Optional Video Overlay */}
              <div className="col-lg-6 text-center">
                <div className="position-relative">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="img-fluid rounded-3 shadow-lg aivideo-banner"

                  // style={{
                  //   // width: "100%",
                  //   // height: "350px",
                  //   // objectFit: "cover",
                  // }}
                  />

                  {/* Overlay Button & Text */}
                  {solution.videoText && (
                    <div
                      className="position-absolute top-50 start-50 translate-middle text-center aivideo-content"
                      style={{
                        placeSelf: "anchor-center",
                        justifyItems: "center",
                      }}
                    >
                      <button
                        className="d-flex align-items-center justify-content-center mb-2 aivideo-btn"
                      // style={{
                      //   // width: "80px",
                      //   // height: "40px",
                      //   // backgroundColor: "rgba(255, 255, 255, 0.95)",
                      //   // border: "none",
                      // }}
                      >
                        {/* ▶ Icon */}
                        <img
                          src={playButton} // 👉 replace with your image path
                          alt="mic"
                        // style={{
                        //   // width: "50px",
                        //   // height: "50px",
                        //   // objectFit: "contain",
                        // }}
                        />
                      </button>
                      <p
                        className="fw-bold mb-0"
                      // style={{
                      //   // fontSize: "18px",
                      //   // color: "#fff",
                      //   // textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
                      // }}
                      >
                        {solution.videoText}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Enterprise Solutions */}
      <section className="py-5 text-white">
        <div className="container enterprise-solutions">
          <h2
            className="fw-bold"
          // style={{ color: "#2d3748", fontSize: "50px", marginBottom: "8px" }}
          >
            Enterprise Solutions
          </h2>

          <p className="mb-4">
            All-in-one solutions for large-scale operations
          </p>
          <div
            className="rounded-3 enterprise-solutions-section"
            style={{
              background: `url(${aiImageBg})`,
              // display: "flex",
              // backgroundSize: "cover",
              // borderRadius: "10px",
            }}
          >
            <div
              className="enterprise-solutions-content"
            //  style={{ width: "50%", padding: "48px 92px 48px 70px" }}
            >
              <h4 className="fw-bold mb-2">AI Call Center</h4>
              <p>
                Designed for large-scale operations, our AI Call Center is built
                to handle complex support processes, multi-channel requirements,
                and high call volumes.
              </p>
              <a href="#" className="btn btn-primary px-4 py-2">
                Consult for FREE
              </a>
            </div>
            <div
              className="enterprise-solutions-image"
            // style={{
            //   // width: "50%",
            //   // alignContent: "center",
            //   // padding: "20px 0px 20px 34px",
            // }}
            >
              <img
                src={aiSolutionsImage}
                alt="mic"
              // style={{
              //   // width: "750px !important",
              //   // height: "270px",
              //   // objectFit: "contain",
              //   // marginLeft: "120px",
              // }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="fw-bold mb-4 faq"
          // style={{
          //   // fontWeight: 700,
          //   // fontSize: "40px",
          //   // lineHeight: "100%",
          //   // letterSpacing: "0%",
          //   // textTransform: "capitalize",
          // }}
          >
            Frequently Asked Questions
          </h2>

          <div className="panel-group wrap" id="bs-collapse">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What happens after the free consultation?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    After the free consultation, our team will analyze your
                    requirements and provide a tailored AI solution roadmap for
                    your project. This includes a detailed plan for development,
                    integration, and deployment.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do I need to pay the full AI Service fee upfront?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    No, we provide flexible payment options. You can start with
                    a deposit and pay as milestones are achieved. We also offer
                    transparent pricing with no hidden fees.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Can I customize my package after posting a project?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Absolutely! You can adjust your AI package anytime to match
                    your business needs. Whether you need more features, faster
                    development, or lower costs, we have options to accommodate
                    your requirements.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    How long does an AI agent take to develop?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Development time varies depending on project complexity —
                    usually between 2–8 weeks.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    I have a specific AI project in mind that's not listed. Can
                    you help me with it?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes! We provide custom AI solutions. Share your idea with
                    us, and we’ll build a tailored plan for you. Whether it's a
                    chatbot, a recommendation system, or any other AI-powered
                    solution, we've got you covered.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    I want to bring my AI Action Plan to life. What steps should
                    I take next?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Start by booking a consultation. Our experts will guide you
                    through strategy, prototyping, and full-scale
                    implementation. Whether you need a chatbot, a recommendation
                    system, or any other AI-powered solution, we've got you
                    covered.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-5 bg-light text-center">
        <div
          className="container cta"
        // style={{ width: "800px" }}
        >
          <h2
          // style={{ fontSize: "45px", fontWeight: "500" }}
          >
            Got something else in mind?
          </h2>

          <p
            className="text-muted mb-4"
          // style={{ fontSize: "24px" }}
          >
            Why wait! Post your project today and let our AI-powered freelancers
            bring your vision to life.
          </p>
          <a href="/contact-us" className="btn btn-primary px-5 py-3">
            Post a Project
          </a>
          {/* <div className="mt-5 opacity-50">
            <img
              src={ai_banner3}
              alt="Decorative Leaves"
              className="img-fluid"
              style={{ maxHeight: "150px" }}
            />
          </div> */}
        </div>
      </section>

      <Footer />

      <style jsx>{`
        .text-shadow {
          text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.6);
        }

        .hero-section {
          background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
        }

        .hero {
          min-height: 90vh;
          padding-top: 80px;
          padding-bottom: 0px;
          background-color: #fafafa;
          position: relative;
          width: 100%;
        }

        .sub-hero {
          top: 0;
          right: 0;
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-position: right center;
          background-size: contain;
          z-index: 1;
        }

        .hero-container {
          z-index: 3;
          width: 100%;
        }

        .hero-subcontainer {
          min-height: 100vh;
          padding-top: 100px;
          padding-left: 200px;
        }

        .hero-content p {
          font-size: clamp(16px, 3vw, 30px);
          font-weight: 400;
          color: #666;
          letter-spacing: 0.5px;
          padding-left: 9%;
        }

        .hero-content h1 {
          font-size: clamp(3.5rem, 8vw, 6.5rem);
          line-height: 0.9;
          font-weight: 900;
          letter-spacing: -10px;
          text-transform: uppercase;
          font-family: "Arial Black", sans-serif;
        }

        .hero-content h1 span {
          // background: linear-gradient(180deg, #e53935 0%, #9c27b0 50%, #1e88e5 100%);
          // webkit-background-clip: text;
          // webkit-text-fill-color: transparent;
          // background-clip: text;
          display: inline-block;
          margin-right: -8px;
        }

        .hero-dec {
          font-size: clamp(14px, 1.5vw, 18px);
          line-height: 1.6;
          max-width: 980px;
          color: #555;
          font-weight: 400;
          padding-left: 9%;
        }

        .hero-btn {
          font-size: 16px;
          font-weight: 600;
          background-color: #4285f4;
          border-color: #4285f4;
          color: #fff;
          box-shadow: 0 4px 15px rgba(66, 133, 244, 0.3);
          border-radius: 6px;
        }

        #try-ai-agent {
          background-color: #ffffff;
          background-repeat: repeat;
          background-size: 300px 300px;
          background-position: center;
          position: relative;
        }

        .tryai-container h2 {
          color: #2d3748;
          fontsize: clamp(2rem, 4vw, 2.5rem);
        }

        .btn:hover {
          transform: translateY(-2px);
          transition: all 0.3s ease;
        }

        .try-category {
          background-color: #f8f9fa;
          color: #6c757d;
          border: 1px solid #dee2e6;
          font-size: 14px;
        }

        .powered-by {
          width: 24px;
          height: 24px;
          background-color: #2d3748;
          border-radius: 4px;
          display: flex;
          align-items: center;
          margin-right: 8px;
          justify-content: center;
        }

        .retell-ai {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
        }

        .try-slider {
          height: 600px;
          background-position: center;
          background-size: cover;
          border-radius: 0px !important;
        }

        .mic-button button {
          width: 80px;
          height: 65px;
        }

        .mic-button img {
          width: 44px;
          height: 44px;
          object-fit: contain;
        }

        .exc-section {
          background-color: "rgba(255, 255, 255, 0.92)",
          z-index: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0px 20px 0px 20px;
        }

        .exc-container {
          width: 100%;
          display: flex;
        }

        .exc-content h2 {
          font-size: 55px;
          font-weight: 500; 
        }

        .exc-content p {
          width: 600px;
        }

        .exc-img {
          margin-top: 40px;
          font-size: 6rem;
          font-weight: 900;
          text-transform: uppercase;
          letter-spacing: 2px;
          background-clip: text;
          padding-left: 250px;
        }

        .exc-img img {
          max-height: 290px;
          margin-right: -110px;
        }

        .aisolution-text h3 {
          font-size: clamp(2rem, 4vw, 3rem);
          color: #2d3748;
          line-height: 1.2;
        }

        .aisolution-text p {
          font-size: 18px;
          line-height: 1.6;
          color: #666;
        }

        .aisolution-text a {
          font-size: 16px;
          font-weight: 600;
          text-decoration: none;
        }

        .aivideo-banner {
          width: 100%;
          height: 350px;
          object-fit: cover;
        }

        .aivideo-content p {
          font-size: 18px;
          text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
          color: #fff;
        }

        .aivideo-btn {
          width: 80px;
          height: 40px;
          border: none;
          background-color: transparent;
        }

        .aivideo-btn img {
          width: 50px;
          height: 50px;
          objectFit: contain;
        }

        .enterprise-solutions h2 {
          color: #2d3748;
          font-size: 50px;
          margin-bottom: 8px;
        }

        .enterprise-solutions-section {
          display: flex;
          background-size: cover;
          border-radius: 10px;
        }

        .enterprise-solutions-content {
          width: 50%;
          padding: 48px 92px 48px 70px;
        }

        .enterprise-solutions-image {
          width: 50%;
          align-content: center;
          padding: 20px 0px 20px 34px;
        }

        .enterprise-solutions-image img {
            width: 750px !important;
            height: 270px;
            object-fit: contain;
            margin-left: 120px;
        }

        .faq {
          font-weight: 700;
          font-size: 40px;
          line-height:  100%;
          letter-spacing: 0%;
          text-transform: capitalize;
        }

        .cta {
          width: 800px;
        }

        .cta h2 {
          font-size: 45px;
          font-weight: 500;
        }

        .cta p {
          font-size: 24px;
        }

        @media (max-width: 768px) {
          .hero-content {
            text-align: center !important;
          }

          .hero-content h1,
          .hero-content p,
          .hero-content .text-start {
            text-align: center !important;
          }

          .hero-subcontainer {
          min-height: 80vh;
          padding-top: 100px;
          padding-left: 0px;
        }
            
        }

        @media (max-width: 576px) {
          .hero-section {
            padding-top: 60px;
          }

          .container {
            padding-left: 15px;
            padding-right: 15px;
          }
        }
      `}</style>
    </Layout>
  )
}

export default AIDevelopment
